import { Content } from "@patternfly/react-core";
import type { FC } from "react";
import { useEffect, useState } from "react";
import aiLoadingGif from "../../../assets/ai-loading.gif";

const THINKING_MESSAGES = [
	"Crawling website content",
	"Reading page structure",
	"Extracting product details",
	"Identifying key features",
	"Analyzing descriptions",
	"Processing support information",
	"Reviewing linked resources",
	"Generating FAQ suggestions",
	"Compiling field data",
	"Validating extracted content",
	"Cross-referencing product info",
	"Preparing field suggestions",
	"Almost there, finalizing results",
];

const GIF_LOOP_MS = 2750;

const GeneratingView: FC = () => {
	const [index, setIndex] = useState(0);
	const [fading, setFading] = useState(false);
	const [dots, setDots] = useState("");

	useEffect(() => {
		const interval = setInterval(() => {
			setIndex((prev) => {
				if (prev >= THINKING_MESSAGES.length - 1) return prev;
				setFading(true);
				setTimeout(() => {
					setIndex((p) => p + 1);
					setFading(false);
				}, 300);
				return prev;
			});
		}, GIF_LOOP_MS);
		return () => clearInterval(interval);
	}, []);

	useEffect(() => {
		const interval = setInterval(() => {
			setDots((prev) => (prev.length >= 3 ? "" : `${prev}.`));
		}, GIF_LOOP_MS / 4);
		return () => clearInterval(interval);
	}, []);

	return (
		<div className="ai-import-modal__generating">
			<img src={aiLoadingGif} alt="Generating product fields" className="ai-import-modal__generating__loading-gif" />
			<Content className="ai-import-modal__thinking">
				<Content
					component="p"
					className={`ai-import-modal__thinking-status ${fading ? "ai-import-modal__thinking-status--fading" : ""}`}
				>
					{THINKING_MESSAGES[index]}
					<span className="ai-import-modal__thinking-dots">{dots}</span>
				</Content>
			</Content>
		</div>
	);
};

export default GeneratingView;
